import React from 'react'
import PropTypes from 'prop-types'

import { useSelector, useDispatch } from 'react-redux'

import { withRouter } from '@piconetworks/router-adapter'

import { GetSelectOrder } from 'apps/lib/CartHelper'
import Wizard from 'common/modules/wizard'
import Loader from 'common/modules/loader'

import Offer from './Offer'

const InjectedOffer = ({ router }) => {
    const dispatch = useDispatch()

    const selectOrderData = useSelector((state) => GetSelectOrder({
        state,
        router,
        dispatch,
    }))

    const popupId = useSelector((state) => Wizard.selectors.thisWizardPopupId({
        state,
        router,
    }))

    const defaultPopup = useSelector(Loader.selectors.getDefaultPopup)
    const popup = useSelector((state) => Loader.selectors.popupGetPopupById(state, popupId))

    const Selection = selectOrderData?.Selection

    return (
        <Offer
            Selection={Selection}
            popupId={popupId || defaultPopup?.id}
            popup={popup || defaultPopup}
        />
    )
}

export default withRouter(InjectedOffer)

InjectedOffer.propTypes = {
    router: PropTypes.object.isRequired,
}
